export default __webpack_public_path__ + "static/media/parkingslot4.d117b8a4.png";